import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';
import DatePicker from '../../../components/DatePicker/index';
import { required, checkDateOnly } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';
export class TravelSupplierItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
    } = this.props;

    return (
      <div className="expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="form-group col-auto">
            <PageSectionHeader>
              <FormattedMessage {...messages.travelSupplierWithIdx} values={{ idx: this.props.index + 1 }} />
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-6 col-md-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.companyName}
              fieldName={messages.companyNameTravelInterruption}
            >
              <Textbox
                disabled={disabled}
                name="fullName"
                type="text"
                onChange={this.onChange('companyName')}
                value={item.companyName}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.companyNameTravelInterruption}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-6 col-sm-6">
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12 col-md-12">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.address}
              fieldName={messages.addressTravelInterruption}
            >
              <Textbox
                disabled={disabled}
                name="address"
                type="text"
                onChange={this.onChange('address')}
                value={item.address}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.addressTravelInterruption}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-4 col-md-4">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.city}
              fieldName={messages.cityTravelInterruption}
            >
              <Textbox
                disabled={disabled}
                name="city"
                type="text"
                onChange={this.onChange('city')}
                value={item.city}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.cityTravelInterruption}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-sm-4 col-md-4">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.state}
              fieldName={messages.stateTravelInterruption}
            >
              <Textbox
                disabled={disabled}
                name="state"
                type="text"
                onChange={this.onChange('state')}
                value={item.state}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.stateTravelInterruption}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-sm-4 col-md-4">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.zipCode}
              fieldName={messages.zipCodeTravelInterruption}
            >
              <Textbox
                disabled={disabled}
                name="zipCode"
                type="text"
                onChange={this.onChange('zipCode')}
                value={item.zipCode}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.zipCodeTravelInterruption}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-4 col-md-4">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.contact}
              fieldName={messages.contactTravelInterruption}
            >
              <Textbox
                disabled={disabled}
                name="contact"
                type="text"
                onChange={this.onChange('contact')}
                value={item.contact}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.contactTravelInterruption}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-sm-4 col-md-4">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.phoneNumber}
              fieldName={messages.phoneNumberTravelInterruption}
            >
              <Textbox
                disabled={disabled}
                name="phoneNumber"
                type="text"
                onChange={this.handleChangePhoneNumber('phoneNumber')}
                value={item.phoneNumber}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.phoneNumberTravelInterruption}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-4 col-sm-4">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.dateOfInitPayment}
              fieldName={messages.dateOfInitialPaymentDeposit}
            >
              <DatePicker
                disabled={disabled}
                name="dateOfInitPayment"
                type="text"
                onDayChange={this.handleDayChange('dateOfInitPayment')}
                value={item.dateOfInitPayment}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateOfInitialPaymentDeposit}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      </div>
    );
  }
}

TravelSupplierItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/components/AddTravelSupplier/TravelSupplierItem.js